//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import DateString from '@models/DateString';

export const getDateRangeTextFromDateStrings = (
  startDate: DateString,
  endDate: DateString,
) => {
  const isOneDay = startDate === endDate;
  if (isOneDay) {
    return DateString.format(startDate, 'MMM D, YYYY');
  }

  const includesYearChange =
    DateString.parse(startDate).year !== DateString.parse(endDate).year;
  const includesMonthChange =
    DateString.parse(startDate).month !== DateString.parse(endDate).month;

  const startDateText = includesYearChange
    ? `${DateString.format(startDate, 'MMM D')}, ${DateString.format(
        startDate,
        'YYYY',
      )}`
    : DateString.format(startDate, 'MMM D');
  const endDateText = includesMonthChange
    ? `${DateString.format(endDate, 'MMM D')}, ${DateString.format(
        endDate,
        'YYYY',
      )}`
    : `${DateString.format(endDate, 'D')}, ${DateString.format(
        endDate,
        'YYYY',
      )}`;

  return `${startDateText} - ${endDateText}`;
};
